import InputTitle from './InputTitle';
export default InputTitle;
